"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subWindow = void 0;
var MockDataStore_1 = require("../store/MockDataStore");
var on = function () {
    return MockDataStore_1.mockStore.getMockData('subWindow.on');
};
var off = function () {
    return MockDataStore_1.mockStore.getMockData('subWindow.off');
};
var open = function () {
    return Promise.resolve(MockDataStore_1.mockStore.getMockData('subWindow.open'));
};
var cancel = function () {
    return Promise.resolve(MockDataStore_1.mockStore.getMockData('subWindow.cancel'));
};
var submit = function () {
    return Promise.resolve(MockDataStore_1.mockStore.getMockData('subWindow.submit'));
};
var close = function () {
    return Promise.resolve(MockDataStore_1.mockStore.getMockData('subWindow.close'));
};
var getAppData = function () {
    return Promise.resolve(MockDataStore_1.mockStore.getMockData('subWindow.getAppData'));
};
exports.subWindow = {
    on: on,
    off: off,
    open: open,
    cancel: cancel,
    submit: submit,
    close: close,
    getAppData: getAppData,
};
